import { apiBaseURL } from "../ProjectConstants";

async function handlePostWorkPlan({ fetch, formData, projectId, headId = "" }) {
  const startDate = formData.startDate?.toLocaleString("en-CA"),
    endDate = formData.endDate?.toLocaleString("en-CA");

  const body = {
    taskName: formData.taskName,
    allocatedEngHours: formData.allocatedEngHours,
    allocatedLabHours: formData.allocatedEngHours,
    startDate: startDate.slice(0, 10),
    endDate: endDate.slice(0, 10),
    supervisorIds: formData.supervisorIds,
    description: formData.description ?? "",
    exitCriteria: formData.exitCriteria ?? "",
    headId: headId,
    projectId: projectId,
  };

  const response = await fetch.post(`${apiBaseURL}/api/projectwo`, body);
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("usePostWorkPlan body", body);
  console.log("usePostWorkPlan response", response);

  return {
    response,
    isDataGood,
  };
}

export default handlePostWorkPlan;
